<div *ngIf="user.profile && (organization.currentOrganization$.value || connection.role.value === 'admin')"
    class="h-full">

    <mat-drawer-container class="h-full" [hasBackdrop]="false" [@.disabled]="disableAnimations">

        <!-- Sidenav -->
        <mat-drawer mode="side" [opened]="breakpoint.lg.value" [mode]="!breakpoint.lg.value ? 'over' : 'side'" #drawer
            [disableClose]="breakpoint.lg.value"
            class="bg-app-sidenav-main-background rounded-none border-r-2 border-app-sidenav-right-border w-[280px]"
            [ngClass]="{'mobile-navigation': !breakpoint.lg.value, 'invisible': !drawer.opened}">

            <div class="flex flex-col h-full overflow-x-hidden">
                <div class="h-[88px] bg-app-sidenav-top-background p-5 flex flex-row justify-between items-center border-b-2 border-app-sidenav-top-border"
                    *ngIf="breakpoint.lg.value">
                    <!-- Logo -->
                    <img *ngIf="organization.logoURL" [src]="organization.logoURL"
                        class="max-w-[200px] max-h-[50px] cursor-pointer" alt="Logo" routerLink="">

                    <!-- New chat button -->
                    <button mat-icon-button aria-label="Nieuwe chat" class="new-chat-button" disableRipple="true"
                        routerLink="/chat/new" [ngClass]="{'ml-auto': !organization.logoURL}">
                        <mat-icon svgIcon="square-pen" class="text-app-sidenav-top-text"></mat-icon>
                    </button>
                </div>

                <!-- User menu -->
                <div class="mobile-user-menu-container" *ngIf="!breakpoint.lg.value">
                    <ng-container *ngTemplateOutlet="userMenuContainer"></ng-container>
                </div>

                <div class="flex flex-col w-full gap-4 overflow-auto h-full">
                    <div class="h-full w-full p-[15px]">
                        <!-- Routes -->
                        <mat-nav-list class="grow h-full flex flex-col">
                            <!-- Chatbot -->
                            <a mat-list-item disableRipple="true" routerLink="/chat/new"
                                [activated]="activeSidenavItem === 'chat'" class="shrink-0">
                                <mat-icon matListItemIcon svgIcon="message-circle"
                                    class="text-app-sidenav-main-text ml-3 mr-[13px]"></mat-icon>
                                <div matListItemTitle class="text-app-sidenav-main-text text-lg" i18n>Chatbot</div>
                            </a>
                            <!-- Collections -->
                            <a mat-list-item disableRipple="true" routerLink="/collections"
                                [activated]="activeSidenavItem === 'collections'" class="shrink-0">
                                <mat-icon matListItemIcon svgIcon="files"
                                    class="text-app-sidenav-main-text ml-3 mr-[13px]"></mat-icon>
                                <div matListItemTitle class="text-app-sidenav-main-text text-lg" i18n>Collecties</div>
                            </a>
                            <!-- Chat feed -->
                            <app-chat-feed class="h-full mb-[35px] "></app-chat-feed>
                            <!-- Settings -->
                            <a mat-list-item disableRipple="true" routerLink="/settings"
                                [activated]="activeSidenavItem === 'settings'"
                                *ngIf="connection.role.value === 'admin' || connection.role.value === 'manager'"
                                class="shrink-0 mt-auto">
                                <mat-icon matListItemIcon svgIcon="settings"
                                    class="text-app-sidenav-main-text ml-3 mr-[13px]"></mat-icon>
                                <div matListItemTitle class="text-app-sidenav-main-text text-lg" i18n>Instellingen
                                </div>
                            </a>
                        </mat-nav-list>
                    </div>
                </div>
            </div>
        </mat-drawer>

        <!-- Page content -->
        <mat-drawer-content class="h-full flex-col flex main-drawer-content overflow-y-hidden">

            <!-- Toolbar for desktop -->
            <div class="flex justify-between items-center toolbar shrink-0 gap-4 border-b-2 border-app-toolbar-border"
                *ngIf="breakpoint.lg.value">
                <!-- Page title -->
                <span [ngSwitch]="activeSidenavItem">
                    <!-- Collections -->
                    <div *ngSwitchCase="'collections'" class="flex flex-row items-center gap-[10px]">
                        <mat-icon svgIcon="files"
                            class="bg-app-button-secondary-background text-app-button-secondary-text w-[34px] h-[34px] p-1 rounded-[5px]">
                        </mat-icon>
                        <p class="text-[26px] text-app-global-text-primary" i18n>Collecties</p>
                    </div>
                    <!-- Settings -->
                    <div *ngSwitchCase="'settings'" class="flex flex-row items-center gap-[10px]">
                        <mat-icon svgIcon="settings"
                            class="bg-app-button-secondary-background text-app-button-secondary-text w-[34px] h-[34px] p-1 rounded-[5px]">
                        </mat-icon>
                        <p class="text-[26px] text-app-global-text-primary" i18n>Instellingen</p>
                    </div>
                    <!-- Chatbot -->
                    <div *ngSwitchDefault class="flex flex-row items-center gap-[10px]">
                        <mat-icon svgIcon="message-circle"
                            class="bg-app-button-secondary-background text-app-button-secondary-text w-[34px] h-[34px] p-1 rounded-[5px]">
                        </mat-icon>
                        <p class="text-[26px] text-app-global-text-primary" i18n>Chatbot</p>
                    </div>
                </span>

                <div class="flex items-center ml-auto">
                    <!-- User menu dropdown -->
                    <ng-container *ngTemplateOutlet="userMenuContainer"></ng-container>
                </div>
            </div>

            <!-- Router outlet -->
            <div class="outlet-container grow overflow-auto">
                <router-outlet></router-outlet>
            </div>

            <!-- Room for stuff that needs to be projected at bottom of page -->
            <div *ngIf="breakpoint.templateRef">
                <ng-container *ngTemplateOutlet="breakpoint.templateRef"></ng-container>
            </div>

            <!-- Bottom bar for mobile view -->
            <div class="w-full h-[75px] flex justify-between items-center overflow-hidden mobile-bottom-bar pl-5 pr-3 gap-2 shrink-0 transition-colors bg-app-mobile-bottom-bar-background"
                *ngIf="!breakpoint.lg.value" [ngClass]="{'sidenav-open': drawer.opened}">
                <button mat-icon-button (click)="toggleDrawer(drawer);" class="scale-125 ml-auto" disableRipple="true"
                    aria-label="menu">
                    <mat-icon [svgIcon]="drawer.opened ? 'x' : 'menu'"
                        class="text-app-mobile-bottom-bar-button"></mat-icon>
                </button>
            </div>

        </mat-drawer-content>

    </mat-drawer-container>
</div>

<!-- User menu container including both the button to open the user menu and the menu itself. -->
<ng-template #userMenuContainer>
    <!-- Button to open menu -->
    <button mat-button [matMenuTriggerFor]="userMenu" color="primary" class="user-menu-button" [disableRipple]="true"
        #userMenuButton>
        <mat-icon svgIcon="chevron-down" iconPositionEnd class="text-app-global-text-primary"></mat-icon>
        <div class="flex items-center gap-2">
            <p
                class="text-app-global-quaternary-contrast text-base bg-app-global-quaternary p-[6px] w-9 h-9 rounded-full initials flex items-center justify-center leading-normal">
                {{user.initials}}
            </p>
            <div class="flex flex-col items-start gap-1">
                <p class="text-app-global-text-primary text-base username">{{user.profile.name}}</p>
            </div>
        </div>
    </button>
    <!-- Menu contents -->
    <mat-menu #userMenu="matMenu" [class]="!breakpoint.lg.value ? 'user-menu mobile' : 'user-menu'">
        <ng-template matMenuContent>
            <div [style.width.px]="getUserMenuButtonWidth()">
                <button mat-menu-item (click)="logout()">
                    <mat-icon svgIcon="log-out"></mat-icon>
                    <span class="tracking-normal text-app-global-text-primary" i18n>Uitloggen</span>
                </button>
            </div>
        </ng-template>
    </mat-menu>
</ng-template>